import React, { useState, useEffect } from 'react';
import axios from 'axios';
import TranslatorBot from './TranslatorBot';
import SignLanguageWidget from './SignLanguageWidget';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AccessibilityBots() {
  const [settings, setSettings] = useState({
    translatorBot: true,
    signLanguageBot: true,
  });
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await axios.get(`${API}/bot-settings`);
        setSettings(response.data);
      } catch (error) {
        // Default to enabled if can't fetch settings
        console.log('Using default bot settings');
      } finally {
        setLoaded(true);
      }
    };

    fetchSettings();

    // Re-check settings periodically (every 30 seconds)
    const interval = setInterval(fetchSettings, 30000);
    return () => clearInterval(interval);
  }, []);

  // Don't render until settings are loaded
  if (!loaded) return null;

  return (
    <>
      {settings.translatorBot && <TranslatorBot />}
      {settings.signLanguageBot && <SignLanguageWidget />}
    </>
  );
}
